define('OutSystems/ClientRuntime/ObjectExtensions',["require", "exports", "./DataTypes"], function (require, exports, DataTypes) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.concatenateMultipleTimes = exports.overrideMethod = exports.roughSizeOf = exports.isEmptyObject = exports.assign = exports.arrayShallowEquals = exports.shallowEquals = exports.getHashCode = void 0;
    function defaultShouldCompareProp() {
        var _ = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            _[_i] = arguments[_i];
        }
        return true;
    }
    function getHashCode(t) {
        var hash = 0;
        var len = t.length;
        if (len === 0) {
            return hash;
        }
        for (var i = 0; i < len; i++) {
            var chr = t.charCodeAt(i);
            hash = (hash << 5) - hash + chr;
            hash |= 0;
        }
        return hash;
    }
    exports.getHashCode = getHashCode;
    function innerShallowEquals(objA, objB) {
        if (!objA || !objB || DataTypes.TypeValidations.isBasicType(objA)) {
            return objA === objB;
        }
        if (objA.fastEquals instanceof Function) {
            return objA.fastEquals(objB);
        }
        return DataTypes.equals(objA, objB);
    }
    function shallowEquals(objA, objB, shouldCompareProperty) {
        if (shouldCompareProperty === void 0) { shouldCompareProperty = defaultShouldCompareProp; }
        if (objA === objB) {
            return true;
        }
        if (objA === null || objB === null || typeof objA !== "object" || typeof objB !== "object") {
            return false;
        }
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) {
            return false;
        }
        var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
        for (var i = 0; i < keysA.length; i++) {
            var propertyName = keysA[i];
            if (shouldCompareProperty(objA, propertyName)) {
                if (!bHasOwnProperty(propertyName)) {
                    return false;
                }
                if (!innerShallowEquals(objA[propertyName], objB[propertyName])) {
                    return false;
                }
            }
        }
        return true;
    }
    exports.shallowEquals = shallowEquals;
    function arrayShallowEquals(objA, objB) {
        if (objA === objB) {
            return true;
        }
        if (objA === null || objB === null || !(objA instanceof Array) || !(objB instanceof Array)) {
            return false;
        }
        if (objA.length !== objB.length) {
            return false;
        }
        for (var i = 0; i < objA.length; i++) {
            if (!innerShallowEquals(objA[i], objB[i])) {
                return false;
            }
        }
        return true;
    }
    exports.arrayShallowEquals = arrayShallowEquals;
    function assign(target) {
        var sources = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            sources[_i - 1] = arguments[_i];
        }
        if (target === null || target === undefined) {
            throw new TypeError("ObjectHelper.assign target cannot be null or undefined");
        }
        var to = Object(target);
        var hasOwnProperty = Object.prototype.hasOwnProperty;
        for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
            var nextSource = sources_1[_a];
            if (nextSource === null || nextSource === undefined) {
                continue;
            }
            var from = Object(nextSource);
            for (var key in from) {
                if (hasOwnProperty.call(from, key)) {
                    to[key] = from[key];
                }
            }
        }
        return to;
    }
    exports.assign = assign;
    function isEmptyObject(obj) {
        return !obj || Object.keys(obj).length === 0;
    }
    exports.isEmptyObject = isEmptyObject;
    function roughSizeOf(object) {
        var visited = [];
        var stack = [object];
        var size = 0;
        while (stack.length) {
            var obj = stack.pop();
            switch (typeof obj) {
                case "boolean":
                    size += 4;
                    break;
                case "number":
                    size += 8;
                    break;
                case "string":
                    size += 2 * obj.length;
                    break;
                case "object":
                    if (visited.indexOf(obj) !== -1) {
                        continue;
                    }
                    visited.push(obj);
                    if (!Array.isArray(obj)) {
                        size += 2 * Object.keys(obj).length;
                    }
                    for (var key in obj) {
                        var childObj = null;
                        try {
                            childObj = obj[key];
                        }
                        catch (e) {
                        }
                        if (childObj) {
                            stack.push(childObj);
                        }
                    }
                    break;
                default:
                    break;
            }
        }
        return size;
    }
    exports.roughSizeOf = roughSizeOf;
    function overrideMethod(prototype, methodName, overridingMethod) {
        var originalMethod = prototype[methodName] || (function () { });
        prototype[methodName] = function () {
            return overridingMethod.apply(this, [].concat(originalMethod, arguments));
        };
    }
    exports.overrideMethod = overrideMethod;
    function concatenateMultipleTimes(source, repetition, repeatCount) {
        var result = source;
        for (var i = 0; i < repeatCount; i++) {
            result += repetition;
        }
        return result;
    }
    exports.concatenateMultipleTimes = concatenateMultipleTimes;
});
//# sourceMappingURL=ObjectExtensions.js.map;
